export enum ContractType {
  ENQUIRY = 1,
  QUOTE = 2,
  ORDER = 3
}

export enum OrderStatus {
  NONE = 0,
  PENDING = 1,
  PLACED = 2,
  CANCELLED = 3
}

export enum OrderStatusSaveStates {
  NOT_APPLICABLE = 0,
  NOT_STARTED = 1,
  STARTED = 2,
  FAILED = 3,
  COMPLETED = 4
}

export const ReportType = {
  NONE: { id: 0, label: 'None' },
  TRADE_QUOTE: { id: 1, label: 'Trade Quote' },
  TRADE_ORDER_CONFIRMATION: { id: 2, label: 'Trade Order Confirmation' },
  TRADE_QUOTE_REQUOTE: { id: 3, label: 'Trade Quote Requote' },
  TRADE_ORDER_REQUOTE: { id: 4, label: 'Trade Order Requote' },
  ENQUIRY: { id: 5, label: 'Enquiry' },
  MANUAL_SURVEY: { id: 6, label: 'Manual Survey' },
  TRADE_ORDER: { id: 7, label: 'Trade Order' },
  PRICE_REQUEST: { id: 8, label: 'Price Request' },
  ITEM_DIAGNOSTIC: { id: 9, label: 'Item Diagnostic' },
  FABRICATOR_QUOTE: { id: 10, label: 'Fabricator Quote' },
  GLASS_ORDER: { id: 11, label: 'Glass Order' },
  WORK_ORDER: { id: 12, label: 'Work Order' },
  CUTTING_LIST: { id: 13, label: 'Cutting List' },
  BNQ_ESTIMATES: { id: 14, label: 'B and Q Estimate' },
  BNQ_QUOTES: { id: 15, label: 'B and Q Quote' },
  FINANCIAL_BREAKDOWN: { id: 16, label: 'Financial Breakdown' },
  PANEL_ORDER: { id: 17, label: 'Panel Order' },
  BAYS_BOWS: { id: 18, label: 'Bay/Bows Layout' },
  MULTISEGMENT: { id: 19, label: 'Multisegment' }
} as const

export type ReportType = (typeof ReportType)[keyof typeof ReportType]

export const ReportTypeById = Object.fromEntries(Object.values(ReportType).map((type) => [type.id, type])) as Record<
  ReportType['id'],
  ReportType
>

export enum ContractImportState {
  NONE = 0,
  READY_TO_IMPORT = 1,
  IMPORTED = 2
}

export enum JobLineItemInputType {
  None = 0,
  FenestrationEngine = 1,
  ImportedLogikal = 2,
  Manual = 3,
  ExtraItem = 4,
  StockItem = 5,
  Pack = 6
}

export enum QuoteStatus {
  NONE = 0,
  CONVERTED = 1
}

export enum FittingType {
  SUPPLY_AND_FIT = 1,
  SUPPLY_ONLY = 2
}

export enum InputType {
  NONE = 0,
  FENESTRATION = 1,
  IMPORTED = 2,
  MANUAL = 3,
  CUSTOMER = 4,
  STOCK_ITEM = 5
}

export enum DeliveryType {
  None = 0,
  Direct = 1,
  ViaBranch = 2,
  ByCarrier = 3
}

export enum DeliveryDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 4,
  Thursday = 8,
  Friday = 16,
  Saturday = 32,
  Sunday = 64
}

export enum SalesSectorType {
  NONE = 0,
  TRADE = 1,
  RETAIL = 2,
  COMMERCIAL = 3,
  NEWBUILD = 4
}

export enum NoteType {
  INTERNAL = 1,
  SUPPLIER = 2,
  CUSTOMER = 3
}
